<template>
  <v-row no-gutters>
    <v-col cols="4">
      <span  v-if="item.label"> {{ item.label }}</span>
      <v-chip variant="outlined" label class="ml-2 pl-2 pr-2" size="small">
       Tree load
      </v-chip>
    </v-col>
    <v-col v-if="!open" class="mt-1 text--secondary"
           cols="8"
    >
      <v-fade-transition leave-absolute>
        <v-row>
          <v-col class="border-right center">
            <v-row class="pl-2 center">
              <v-col class="ml-1">
                <v-row>
                  <v-col class="pa-0">
                    <small> Top </small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-0">
                    <small> tree </small>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                <v-row>
                  <v-col class="pa-0">
                    <small>{{ item.top_of_tree_x }}</small>
                  </v-col>
                  <v-col class="pa-0">
                    <small>x</small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-0">
                    <small>{{ item.top_of_tree_z }}</small>
                  </v-col>
                  <v-col class="pa-0">
                    <small>z</small>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-col>
          <v-col class="border-right center">
            <v-row class="pl-2 center">
              <v-col class="ml-1">
                <v-row>
                  <v-col class="pa-0">
                    <small> Wind </small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-0">
                    <small> force </small>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                {{ item.wind_force }}
              </v-col>
            </v-row>
          </v-col>
          <v-col class="border-right center">
            <v-row class="pl-2 center">
              <v-col class="ma-1">
                <v-row>
                  <v-col class="pa-0">
                    <small> Width </small>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col class="pa-0">
                    <small> root </small>
                  </v-col>
                </v-row>
              </v-col>
              <v-col>
                {{ item.width_root_zone }}
              </v-col>

            </v-row>
          </v-col>

          <v-col class="center">
            <div>
              <small> Spread </small>{{ item.spread }}
            </div>
          </v-col>
        </v-row>
      </v-fade-transition>
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'TreeLoadHeader',
  props: {
    item: {},
    open: {}
  }
}
</script>
<style scoped>
.border-right {
  border-right: solid 1px rgba(0, 0, 0, 0.25);
}

</style>